import React, { useState, useRef } from "react";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import { registerUser } from "../utils/api/userAPI";
import { toast } from "sonner";
import { onboardUser } from "../utils/api/authAPI";
// import { isVerifiedPhoneNumber, sendOTP, verifyOTP } from "../utils/api/phoneVerificationAPI";
// import ReCAPTCHA from "react-google-recaptcha";

const SignUpLayer = () => {
  const navigate = useNavigate();
  // const recaptchaRef = useRef(null);

  const [isSubmitting, setIsSubmitting] = useState(false);
  // const [otpSent, setOtpSent] = useState(false);
  // const [otp, setOtp] = useState("");
  // const [otpVerified, setOtpVerified] = useState(false);
  // const [recaptchaToken, setRecaptchaToken] = useState("");

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /*
  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
  };

  const handleSendOTP = () => {
    if (!/^\d{10}$/.test(formData.phone.trim())) {
      toast.error("Enter a valid 10-digit phone number before sending OTP");
      return;
    }

    if (!recaptchaToken) {
      toast.error("Please complete the reCAPTCHA");
      return;
    }

    const phoneNumber = `91${formData.phone.trim()}`;
    sendOTP(phoneNumber)
      .then(() => {
        setOtpSent(true);
        toast.success("OTP sent to your phone!");
        recaptchaRef.current.reset(); // reset reCAPTCHA after success
        setRecaptchaToken("");
      })
      .catch(() => {
        toast.error("Failed to send OTP. Try again.");
      });
  };

  const handleVerifyOTP = () => {
    const phoneNumber = `91${formData.phone.trim()}`;
    verifyOTP({ phoneNumber, otp }).then((res) => {
      if (res.message === "Invalid or expired OTP") {
        toast.error("Invalid or expired OTP. Please try again.");
        return;
      }
      isVerifiedPhoneNumber(phoneNumber).then((response) => {
        if (response.verified) {
          setOtpVerified(true);
          toast.success("Phone number verified!");
        }
      });
    });
  };
  */

  const validateFields = () => {
    const { firstName, lastName, email, phone } = formData;

    if (!firstName.trim() || !lastName.trim()) {
      toast.error("Name fields cannot be empty");
      return false;
    }

    if (!/^\S+@\S+\.\S+$/.test(email.trim())) {
      toast.error("Enter a valid email address");
      return false;
    }

    if (!/^\d{10}$/.test(phone.trim())) {
      toast.error("Phone number must be 10 digits");
      return false;
    }

    // if (!otpVerified) {
    //   toast.error("Please verify your phone number");
    //   return false;
    // }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateFields()) return;

    setIsSubmitting(true);
    try {
      const payload = {
        ...formData,
        email: formData.email.trim(),
        phone: `+91${formData.phone.trim()}`
      };

      await onboardUser(payload);
      toast.success("Registered! Check email (incl. spam) for password.");
      navigate("/sign-in");
    } catch (error) {
      const message = error?.message || "Something went wrong during registration";
      toast.error(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="auth bg-base d-flex flex-wrap">
      <div className="auth-left d-lg-block d-none">
        <div className="d-flex align-items-center flex-column h-100 justify-content-center" style={{ backgroundColor: "black" }}>
          <h1 style={{ color: "white", fontSize: "1.5rem", fontWeight: "bold" }}>
            Put <span style={{ color: "#3EE6A8" }}>AI</span> To Work
          </h1>

          <img src="/assets/images/auth/wave.gif" alt="Wave animation" style={{ width: "80%", maxWidth: "400px", marginTop: "0" }} />
        </div>
      </div>

      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100">
          <div>
            <Link to="/" className="mb-40 max-w-290-px">
              <img src="/assets/images/logo.png" alt="Logo" />
            </Link>
            <h4 className="mb-12">Sign Up to your Account</h4>
            <p className="mb-32 text-secondary-light text-lg">Welcome! Please enter your details</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="flex" style={{ gap: "16px" }}>
              <div className="icon-field mb-16 flex-1">
                <span className="icon top-50 translate-middle-y"><Icon icon="f7:person" /></span>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  placeholder="First Name"
                  required
                />
              </div>
              <div className="icon-field mb-16 flex-1">
                <span className="icon top-50 translate-middle-y"><Icon icon="f7:person" /></span>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  placeholder="Last Name"
                  required
                />
              </div>
            </div>

            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y"><Icon icon="mage:email" /></span>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-control h-56-px bg-neutral-50 radius-12"
                placeholder="Email"
                required
              />
            </div>

            <div className="icon-field mb-16">
              <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "100%" }}>
                <select
                  value="+91"
                  className="bg-neutral-50 h-56-px radius-12"
                  disabled
                  style={{ border: "1px solid #ccc", padding: "15px 12px", cursor: "not-allowed" }}
                >
                  <option value="+91">+91</option>
                </select>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  style={{ paddingLeft: "12px" }}
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  placeholder="Phone Number"
                  required
                />

                {/* 
                <button
                  type="button"
                  onClick={handleSendOTP}
                  className="btn btn-primary-500"
                  style={{
                    whiteSpace: "nowrap",
                    padding: "14px 16px",
                    fontSize: "14px",
                    borderRadius: "8px",
                  }}
                >
                  Send OTP
                </button> 
                */}
              </div>
            </div>

            {/* 
            <div className="mb-3">
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey="6LegEIUrAAAAALovytFgSz7NYTN_N6vSC7ZvE-QG"
                onChange={handleRecaptchaChange}
              />
            </div>
            */}

            {/* 
            {otpSent && (
              <div style={{ marginBottom: "16px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "100%" }}>
                  <input
                    type="text"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    placeholder="Enter OTP"
                    style={{
                      flex: 1,
                      padding: "12px",
                      borderRadius: "8px",
                      border: "1px solid #ccc",
                      fontSize: "14px",
                    }}
                  />
                  {!otpVerified ? (
                    <button
                      type="button"
                      onClick={handleVerifyOTP}
                      className="btn btn-primary-500"
                      style={{
                        whiteSpace: "nowrap",
                        padding: "12px 16px",
                        fontSize: "14px",
                      }}
                    >
                      Verify
                    </button>
                  ) : (
                    <Icon icon="mdi:check-circle-outline" style={{ color: "green", fontSize: "24px" }} />
                  )}
                </div>
                <span style={{ fontSize: "12px", color: "#777" }}>
                  Enter the OTP sent to your number
                </span>
              </div>
            )}
            */}

            <div className="mb-16">
              <div className="form-check style-check d-flex align-items-start">
                <input
                  className="form-check-input border border-neutral-300 mt-4"
                  type="checkbox"
                  id="terms"
                  required
                />
                <label className="form-check-label text-sm" htmlFor="terms">
                  By creating an account, you agree to the{" "}
                  <a
                    href="https://www.callhq.ai/terms"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary-600 fw-semibold"
                  >
                    Terms & Conditions
                  </a>
                  {" "}and our{" "}
                  <a
                    href="https://www.callhq.ai/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary-600 fw-semibold"
                  >
                    Privacy Policy
                  </a>

                </label>
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary-500 text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
              disabled={isSubmitting /* || !otpVerified */}
              title={isSubmitting ? "Please wait..." : /* !otpVerified ? "Verify number to sign up" : */ ""}
            >
              {isSubmitting ? "Signing Up..." : "Sign Up"}
            </button>

            <div className="mt-32 text-center text-sm">
              <p className="mb-0">
                Already have an account?{" "}
                <Link to="/sign-in" className="text-primary-600 fw-semibold">
                  Sign In
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SignUpLayer;
